export default {"src":"/_next/static/media/Scoutompanies.df5c61c4.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};